<template>
  <div class="main-content">
    <div class="container-fluid">
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary" @click="openAddBrandDialog()">
          Aggiungi brand
        </button>
      </div>
      <b-table striped hover :items="items" :fields="fields" :busy="loading">
        <template #cell(actions)="row">
          <i
            class="fas fa-edit cursor-pointer"
            @click="openEditDialog(row)"
          ></i>
        </template>

        <template #table-busy>
          <div class="text-center text-secondary my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
      </b-table>
    </div>

    <AddElementDialog
      :title="'Aggiungi brand'"
      :size="'sm'"
      @add="addBrand($event)"
    />

    <EditElementDialog
      :title="'Modifica brand'"
      :size="'sm'"
      :elementName="'brand'"
      :element="selectedElement"
      @edit="editBrand($event)"
    />
  </div>
</template>

<script>
import BrandsService from "@/services/brands";

export default {
  data() {
    return {
      fields: [
        {
          key: "uuid",
          sortable: false,
        },
        {
          key: "brand",
          sortable: false,
        },
        {
          key: "elementi",
          sortable: false,
        },
        {
          key: "actions",
          sortable: false,
          label: "",
        },
      ],
      items: [],
      loading: false,
      selectedElement: null,
    };
  },
  methods: {
    async getBrands() {
      this.loading = true;

      try {
        const { docs } = await BrandsService.getBrands(this.$db);
        const brands = docs.map((doc) => doc.data());

        this.items = brands.map((brand) => {
          return {
            uuid: brand.uuid,
            brand: brand.value,
            elementi: `${brand.counter} elementi`,
          };
        });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },

    openAddBrandDialog() {
      this.$root.$emit("bv::show::modal", "add-element-modal");
    },

    async addBrand(brand) {
      this.$root.$emit("bv::hide::modal", "add-element-modal");
      this.loading = true;

      try {
        await BrandsService.addBrand(this.$db, brand);

        this.getBrands();
      } catch (error) {
        this.loading = false;
      }
    },

    openEditDialog(element) {
      this.selectedElement = element.item;

      this.$root.$emit("bv::show::modal", "edit-element-modal");
    },

    async editBrand(brand) {
      this.$root.$emit("bv::hide::modal", "edit-element-modal");

      try {
        this.loading = true;

        await BrandsService.editBrand(this.$db, brand.uuid, brand);

        this.getBrands();
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.$store.dispatch("utils/setSectionName", "Brand");

    this.getBrands();
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/cms/brand/BrandPage.vue